<template>
  <v-list v-if="items" two-line>
    <template v-for="(item, index) in items">
      <v-subheader v-if="item.header" :key="item.header">
        {{ item.header }}
      </v-subheader>

      <v-divider v-else-if="item.divider" :key="index" :inset="item.inset" />

      <v-list-tile v-else :key="item.title" avatar @click="onClick(item)">
        <v-list-tile-avatar>
          <img :title="item.avatarTitle" :src="item.avatar" />
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title v-html="item.title" />
          <v-list-tile-sub-title v-html="item.subtitle" />
        </v-list-tile-content>
      </v-list-tile>
    </template>

    <div class="px-2" v-if="items.length === 0">
      {{ loading ? "Please wait a moment" : "No record found" }}
    </div>
  </v-list>
  <div v-else-if="loading" class="px-2 py-2">Please wait a moment</div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: undefined
    },

    clickable: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick(item) {
      if (!this.clickable) return;

      this.$emit("click", item);
    }
  }
};
</script>
